import React from "react";
import { Paper, Typography, Stack, Box, LinearProgress } from "@mui/material";
import ReportProblemRoundedIcon from "@mui/icons-material/ReportProblemRounded";

const risks = [
  { name: "Corporate Day Summit", issue: "Conversão baixa", score: 78 },
  { name: "Arena Fight Night", issue: "Checkout com abandono", score: 64 },
  { name: "Festa Neon", issue: "Tráfego alto / venda baixa", score: 58 },
  { name: "Workshop Premium", issue: "Ticket alto travando", score: 52 },
];

export default function RiskEventsCard() {
  return (
    <Paper
      sx={{
        p: { xs: 2.2, md: 2.6 },
        borderRadius: 1,
        height: "100%",
        minHeight: { xs: 260, md: 320 },
      }}
    >
      <Stack direction="row" spacing={1} alignItems="center" mb={1.2}>
        <ReportProblemRoundedIcon color="warning" />
        <Typography fontWeight={950}>Eventos em risco</Typography>
      </Stack>

      <Typography fontSize={12} color="text.secondary" mb={2}>
        Priorização por risco (abandono, conversão, preço, gargalos).
      </Typography>

      <Stack spacing={1.6}>
        {risks.map((r, i) => (
          <Box key={i}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="baseline"
            >
              <Typography fontWeight={850}>{r.name}</Typography>
              <Typography fontSize={12} color="text.secondary">
                {r.score}/100
              </Typography>
            </Stack>

            <Typography fontSize={12} color="text.secondary" sx={{ mb: 0.6 }}>
              {r.issue}
            </Typography>

            <Box sx={{ borderRadius: 1, overflow: "hidden" }}>
              <LinearProgress
                variant="determinate"
                value={r.score}
                sx={{ height: 10, borderRadius: 0 }}
              />
            </Box>
          </Box>
        ))}
      </Stack>
    </Paper>
  );
}
